/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PaymentListAliases {
  CARD_PAYMENT = 'card-payment',
  CHECKLIST_STATUS = 'checklist-status',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_PICKER_INITIAL_DATE = 'date-picker-initial-date',
  DECK_PAYMENTS_LIST = 'deck-payments-list',
  FETCH_PAYMENT = 'fetch-payment',
  FILTER_FIELD_FROM_DATE = 'filter-field-from-date',
  FILTER_FIELD_PAYMENT_STATUS = 'filter-field-payment-status',
  FILTER_PAYMENTS_LIST = 'filter-payments-list',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  LAYOUT_PAYMENT = 'layout-payment',
  LAYOUT_PAYMENTS_LIST = 'layout-payments-list',
  MAPPER_PAYMENT = 'mapper-payment',
  PANEL_0 = 'panel-0',
  PANEL_PAYMENT = 'panel-payment',
  PANEL_PAYMENTS = 'panel-payments',
  TEXT_PAYMENT = 'text-payment',
}
export { PaymentListAliases };
